import React from "react"
import { useFieldArray, useFormContext } from "react-hook-form"
import ConditionField from "./ConditionField"
import { Button } from "reactstrap"
import DropdownRHF from "components/RHF/DropdownRHF"
import { field_matchType } from "constants/select-options"
import { t } from "i18next"

function ConditionsFieldArray() {
  const { control, setValue, watch } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: "group.conditions",
  })
  const watch_conditions = watch("group.conditions")
  const clearAllConditions = () => setValue("group.conditions", [])
  const removeCondition = idx => remove(idx)

  return (
    <div className="p-3 rounded-3 bg-light-subtle border border-light-subtle">
      {watch_conditions.length >= 2 && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="mb-0">
            {t("show records that match")}
            <DropdownRHF
              name="group.operations"
              control={control}
              options={field_matchType}
              className="d-inline-flex mx-2"
              size="sm"
            />
            {t("of these conditions")}
          </div>
          <Button size="sm" onClick={clearAllConditions}>
            {t("clear all")}
          </Button>
        </div>
      )}
      {fields.map((field, idx) => {
        return (
          <ConditionField
            key={field.id}
            idx={idx}
            removeCondition={removeCondition}
          />
        )
      })}
      <Button
        type="button"
        size="sm"
        onClick={() => append({ type: "", value: "" })}
      >
       {t("add condition")}
      </Button>
    </div>
  )
}

export default ConditionsFieldArray
